<template>
  <div class="map-container">
    <BasicMap
      ref="map"
      :options="mapOption"
      :layer-options="layerOptions"
      need-bound-layer
      need-point-layer
      enable-point-hover
      @mapInited="mapInited"
      @pointClick="handlePointClick"
      @pointHover="handlePointHover"
    >
      <template #pointPopup="{ data }">
        <div v-if="data.name" class="point-popup-wrap">
          <span>{{ data.name }}</span>
        </div>
      </template>
    </BasicMap>
  </div>
</template>

<script>
import hmap from 'hmap'
import BasicMap from '@/components/TownPanel/BasicMap/BasicMap.vue'
import { mapUtil } from '@/components/TownPanel/BasicMap/mapUtils'
import axios from 'axios'
import pointIconBlue from '@/assets/images/panel/map/point/icon-blue.png'
import pointIconYellow from '@/assets/images/panel/map/point/icon-yellow.png'
import pointIconOrange from '@/assets/images/panel/map/point/icon-orange.png'
import pointIconRed from '@/assets/images/panel/map/point/icon-red.png'
// import pointIconCluster from '@/assets/images/panel/map/point/icon-cluster.png'
import { inherentRiskPoints, existingRiskPpints } from '../mockData/mockData'

// 0-低风险 1-一般风险 2-较大风险 3-重大风险
const iconArr = [pointIconBlue, pointIconYellow, pointIconOrange, pointIconRed]
const POINT_ICON_SIZE = 32
export default {
  components: {
    BasicMap
  },
  props: {
    pointFilterKey: {
      type: String,
      default: '3,2,1,0'
    }
  },
  data() {
    this.mapInstance = null
    this.layers = null
    return {
      mapOption: {
        crs: new hmap.proj.Crs('900913'),
        zoom: 16,
        minLevel: 13,
        center: mapUtil.coord(114.136675, 22.74697) // 凤岗镇
      },
      layerOptions: [
        {
          name: '高德影像图层',
          type: 'TMS', // 目前支持两种type:VectorTile、TMS
          url: 'https://webst03.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}', // 影像地图
          // url:
          //   'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
          layerOption: {
            matrixOrigin: new hmap.basetype.Coordinate(-20037508.342789, 20037508.342789),
            dataFormat: 'png',
            visibility: true
          }
        }
      ],
      allPointList: [],
      pointList: []
    }
  },
  watch: {
    pointList() {
      this.updatePointList()
    },
    pointFilterKey(val) {
      const keys = val.split(',')
      this.pointList = this.allPointList.filter(i => keys.includes(i.riskLevel))
    }
  },
  created() {
    mapUtil.setCrs('900913')
  },
  methods: {
    getPointData(riskType = 0) {
      const data = riskType === 0 ? inherentRiskPoints : existingRiskPpints
      this.allPointList = data.map(i => {
        return {
          ...i,
          iconUrl: iconArr[i.riskLevel],
          iconWidth: POINT_ICON_SIZE,
          iconHeight: POINT_ICON_SIZE
        }
      })
      const keys = this.pointFilterKey
      this.pointList = this.allPointList.filter(i => keys.includes(i.riskLevel))
    },
    mapInited(mapInstance, layers) {
      this.mapInstance = mapInstance
      this.layers = layers
      this.getTownBound()
      this.getPointData()
    },
    getTownBound() {
      const assetsUrl = process.env.BASE_URL + process.env.VUE_APP_ASSETS
      axios.get(`${assetsUrl}/map-data/fenggangArea.json`).then(res => {
        // axios.get(`${assetsUrl}/map-data/fenggangBound.json`).then(res => {
        const { data } = res
        this.drawArea(data)
        this.drawBound(data) // 绘制行政区划边框，增加offset模拟立体阴影
        this.drawBound(data, 8)
      })
    },
    drawArea(GeoJSON, onlyBorder = false) {
      // geometry.transform 转换坐标画出来有偏移...
      // const geoJSON = new hmap.format.GeoJSON()
      // const geometry = geoJSON.readGeometry(GeoJSON)
      // geometry.transform('4326', '900913')
      // const feature = new hmap.feature.Vector(geometry, {}, this.createStyle())
      // this.layers.boundLayer && this.layers.boundLayer.addFeature(feature)
      // this.townExtent = geometry.getExtent()

      const lineRings = GeoJSON.coordinates[0].map(coordArr => {
        const pts = coordArr.map(value => {
          const coord = mapUtil.coord(...value, true) // 加密转换
          const pt = new hmap.geom.Point(coord)
          return pt
        })
        return new hmap.geom.LinearRing(pts)
      })
      const polygon = new hmap.geom.Polygon(lineRings)
      const feature = new hmap.feature.Vector(polygon, {}, this.createStyle(onlyBorder))
      this.layers.boundLayer && this.layers.boundLayer.addFeature(feature)
      this.townExtent = polygon.getExtent()
      this.resetMapCenterExt()
    },
    drawBound(GeoJSON, offset = 4) {
      const pts = GeoJSON.coordinates[0][0].map(arr => {
        return new hmap.geom.Point(mapUtil.coord(...arr, true))
      })
      const lineGeom = new hmap.geom.Line(pts)
      const style = new hmap.style.Style({
        lineSymbols: [
          new hmap.style.LineSymbol({
            color: new hmap.style.Color(97, 221, 243, 0.5),
            lineOffset: new hmap.basetype.Offset(0, -offset), // 面要素不生效
            width: 2
          })
        ]
      })
      const lineFeature = new hmap.feature.Vector(lineGeom, {}, style)
      this.layers.boundLayer && this.layers.boundLayer.addFeature(lineFeature)
    },
    createStyle(onlyBorder = false) {
      const lineSymbol = new hmap.style.LineSymbol({
        color: onlyBorder
          ? new hmap.style.Color(97, 221, 243, 0.8)
          : new hmap.style.Color(97, 221, 243, 0.9),
        width: onlyBorder ? 3 : 3
      })
      // const pointSymbol = new hmap.style.Circle({
      //   radius: 20,
      //   fillColor: new hmap.style.Color(12, 255, 120, 1)
      // })
      const areaColor = onlyBorder
        ? new hmap.style.Color(70, 193, 214, 0) // 只画边框时area不展示
        : new hmap.style.Color(70, 193, 214, 0.16)
      const fillSymbol = new hmap.style.ColorFill(areaColor)
      // const fillSymbol = new hmap.style.RadialGradientFill(
      //   new hmap.style.Color(12, 255, 120),
      //   new hmap.style.Color(255, 255, 255)
      // )
      return new hmap.style.Style({
        fillSymbols: [fillSymbol],
        lineSymbols: [lineSymbol]
        // markerSymbols: [pointSymbol]
      })
    },
    resetMapCenterExt() {
      if (!this.mapInstance) return
      if (this.townExtent) {
        this.mapInstance.zoomToExt(this.townExtent)
        return
      }
      const { center, zoom } = this.mapOption
      this.mapInstance.setCenter(center, zoom)
    },
    updatePointList() {
      if (!this.mapInstance) return
      this.layers.pointLayer.removeAllFeatures()
      // this.layers.clusterLayer.removeAllFeatures()
      const points = this.pointList.map(point => {
        const pointVector = mapUtil.vector(
          mapUtil.point(point.longitude, point.latitude),
          mapUtil.icon(point.iconUrl, point.iconWidth, point.iconHeight),
          point
        )
        if (point.textStyle) {
          const originStyle = pointVector.getStyle()
          const { text, color, size, offset } = point.textStyle
          const textStyle = mapUtil.text(text, color, size, offset)
          originStyle.setTextSymbols([textStyle])
        }
        return pointVector
      })
      this.layers.pointLayer.addFeatures(points)

      // BUG：2.5.0前的版本，聚合图层在非聚合状态时要素的样式始终是最后一个要素样式的
      // this.layers.clusterLayer.addFeatures(points)
    },
    handlePointClick(e, points) {
      const point = points[0].getAttributes()
      window.console.log('跳转企业看板', point)
    },
    handlePointHover(e, points) {
      window.console.log(points)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  height: 100%;
  width: 100%;
}
.point-popup-wrap {
  padding: 1px 4px;
  max-width: 200px;
  background-color: rgba(38, 90, 133, 0.6);
  border: 2px solid rgb(17, 78, 128, 0.6);
  border-radius: 6px;
  color: #fff;
  text-align: center;
}
</style>
